import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import CatalogPage from './pages/CatalogPage';
import CartPage from './pages/CartPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderStatusPage from './pages/OrderStatusPage';
import AboutPage from './pages/AboutPage';
import TrainingGuidesPage from './pages/TrainingGuidesPage';
import AdminPage from './pages/AdminPage';
import AdminLoginPage from './pages/AdminLoginPage';

// Protected Admin Route
function ProtectedAdminRoute({ children }) {
    const { user } = useAuth();
    
    if (!user || user.role !== 'admin') {
        return <Navigate to="/admin-login" replace />;
    }
    return children;
}

function AppContent() {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith('/admin') && location.pathname !== '/admin-login';
    const isAdminLogin = location.pathname === '/admin-login';
    // Checkout and the post-purchase order page are focused flows: the nav
    // invites the customer to wander off mid-purchase, so it is hidden on both.
    // Each carries its own slim header with a way back.
    const isOrderPage = location.pathname.startsWith('/order/');
    const isFocusedFlow = location.pathname === '/checkout' || isOrderPage;

    return (
        <div className="flex flex-col min-h-screen">
            {!isAdminRoute && !isAdminLogin && !isFocusedFlow && <Navbar />}
            <main className="flex-grow">
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/catalog" element={<CatalogPage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/checkout" element={
                        <CheckoutPage />
                    } />
                    {/* Reached by an unguessable token, so guests can follow
                        their own order without an account. */}
                    <Route path="/order/:token" element={<OrderStatusPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/training-guides" element={<TrainingGuidesPage />} />
                    <Route path="/admin-login" element={<AdminLoginPage />} />
                    <Route 
                        path="/admin" 
                        element={
                            <ProtectedAdminRoute>
                                <AdminPage />
                            </ProtectedAdminRoute>
                        } 
                    />
                </Routes>
            </main>
            {!isAdminRoute && !isAdminLogin && !isOrderPage && <Footer />}
        </div>
    );
}

function App() {
    return (
        <Router>
            <AuthProvider>
                <CartProvider>
                    <CurrencyProvider>
                        <AppContent />
                    </CurrencyProvider>
                </CartProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
